import React from 'react';
import InvoiceReportFunctional from './components/invoice-report-functional';

const InvoiceReport = () => {
	return <InvoiceReportFunctional />;
};

export default InvoiceReport;
    